import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import htmlToPdf from '@/utils/js/htmlToPdf.js'
Vue.use(htmlToPdf)
import {mapState, mapMutations, mapGetters, mapActions} from 'vuex'
import { Button, message ,info} from 'ant-design-vue'
import animate from 'animate.css'
Vue.use(animate)


import vueEsign from 'vue-esign'
Vue.use(vueEsign)
Vue.prototype.$http = axios;
Vue.prototype.$store = store;



let baseUrls = ''
if (process.env.NODE_ENV =='development') {
  // 开发环境的url
  baseUrls = '/'
} else if (process.env.NODE_ENV == 'production') {
  // 正式环境的 request url
  baseUrls = 'https://wdrmapi.zkshare.com/'
}

axios.defaults.baseURL = baseUrls

axios.defaults.timeout = 10000;
axios.interceptors.request.use(
  config => {
	  if(document.location.hash!='#/'){
		  store.commit('updateSpin',true)
	  }
		  

	 
	 console.log(config)
  // 判断是否存在token，如果存在的话，则每个http header都加上token
    let token = localStorage.getItem('Authorization')
    if (!config.headers.hasOwnProperty('Authorization') && token) {
      config.headers.Authorization = 'Bearer ' +token;
	 
    }
	// else if(!token){
	// 	config.headers.Authorization = ''
	// }
    return config;
  },
  error => {
    return Promise.reject(error);
  });
Vue.config.productionTip = false
axios.interceptors.response.use(response => {
	let notDate = window.localStorage.getItem('times')
	var  myDate = new Date()
	 let FullYear =  myDate.getFullYear()
	 let Month = myDate.getMonth()+1
	 let Dates = myDate.getDate() 
	 let Hours =  myDate.getHours()+2 //获取当前小时数(0-23)
	 let Minutes =  myDate.getMinutes() //获取当前分钟数(0-59)
	 let Seconds =  myDate.getSeconds(); //获取当前秒数(0-59)
	 if(notDate&&myDate.getHours()>new Date(notDate).getHours()){
		 message.error('登录已过期，请重新登录')
		 window.localStorage.clear()
		 window.sessionStorage.clear()
		  location.reload()
	 }
	 let mydates = FullYear+"-"+Month+'-'+Dates+" "+Hours+":"+Minutes+":"+Seconds
	 if(window.localStorage.getItem('Authorization')){
		 window.localStorage.setItem('times',mydates)
	 }
	 
    store.commit('updateSpin',false)
	// window.localStorage.setItem('times',)
	console.log(mydates)
    return response
}, error => {
	
	 var config = error.config;
	 console.log(config)
	 store.commit('updateSpin',false)
	 
	 message.error(''+error)
	 if (error.response && error.response.status === 401) {
	       // 清除localStorage
	      localStorage.clear();
	      // 提示用户重新登录
	      message.error('登录信息已失效，请重新登录')
	      location.reload()
	 }
    return Promise.reject(error)
})

router.beforeEach((to,from,next)=>{
  if(to.path!="/instrumentDetail"&&to.path!="/accessControl2"&&to.path!="/accessControl"&&to.path!="/instrument"&&to.path!="/instrument2"&&to.path!="/aniQualification"&&to.path!="/coreQualification"&&to.path!="/animalApply"&&to.path!="/IACUC"&&to.path!="/consumable"&&to.path.split('/')[1]!="core"||window.localStorage.getItem('Authorization')){
	  // if(to.meta.title){
	  // 	document.title = to.meta.title
	  // }
	  document.title = '武汉大学人民医院——科研实验室管理系统'
    next();
  }else{
	  // Vue.prototype.$message = message;
	  message.error("无权访问：用户未登录，已跳转登录，请登录后再访问");
	  setTimeout(function(){
		   router.push({path:'/blanksss'})
		   router.push({path:'/login'})
	  },500)
	 
  }
})
import ant from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';

Vue.use(ant)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
